import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeliveryService } from '../../services/delivery.service';
import { Delivery, DeliveryStatusAux, DeliveryStatus } from '../../models/delivery.schema';
import { AuthStatusService } from '../../services/auth-status.service';
import { MatDialog } from '@angular/material/dialog';
import { DeliveryLinkDialogComponent } from '../delivery-link-dialog/delivery-link-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { ServiceModel } from 'src/app/models/service.schems';
import { Service } from 'src/app/services/service.service';
import { ShowImageComponent } from '../show-image/show-image.component';
import { Expert } from 'src/app/models/expert.schema';
import { DeliveryExpertFormComponent } from '../delivery-expert-form/delivery-expert-form.component';
import { PartialUpdateDeliveryComponent } from '../partial-update-delivery/partial-update-delivery.component';
import { Partner } from 'src/app/models/partner.schema';
import { PartnerService } from 'src/app/services/partner.service';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { ShowOtpComponent } from '../show-otp/show-otp.component';
import { ShowSignatureComponent } from '../show-signature/show-signature.component';
import { SpinnerService } from 'src/app/services/spinner.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import * as env from '../../../environments/environment';
import { ExpertService } from 'src/app/services/expert.service';
import { User } from 'src/app/models/user.schema';



@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.scss']
})
export class DeliveryComponent implements OnInit {
  public user: any;
  public deliveries: Delivery[] = [];
  public groups: string[];
  public delivery: Delivery;
  public deliveryStatusAux = DeliveryStatusAux;
  public deliveryStatus = DeliveryStatus;
  public selected:any='';
  public serviceDetails:any;
  public services :ServiceModel[] = [];
  public loggedInExpert: Expert;
  public deliveryId: string;
  loggedInPartner: Partner;
  expertIdentityCheck: boolean;
  customerVerification: boolean;
  deliveryReadByPartner: string;
  deliveryReadByExpert: string
  createdByUserName: string;
  showCustomerInformation: boolean = true;
  showDeliveryUpdates = false;
  partners: Partner[] = [];
  users: User[] = [];
  showDeliveryTimeline = false;

  /*
  deliveryData = {
    id: 1234,
    status: 'delivering',
    actualDate: new Date(),
    fromTime: '10:00',
    toTime: '14:00',
    serviceName: 'Express Delivery',
    serviceType: 'Fixed Price',
    productValue: 100,
    receiverName: 'John Doe',
    receiverPhone: '123-456-7890',
    address: '123 Main St, City, Country',
    notes: 'Special request: Fragile item',
    createdAt: new Date(),
    deliveryStartedAt: new Date(),
    deliveryDeliveredAt: new Date()
  };
  */

  constructor(
    private _snackBar: MatSnackBar,
    private authStatusService: AuthStatusService,
    private route: ActivatedRoute,
    private router: Router,
    private deliveryService: DeliveryService,
    public dialog: MatDialog,
    private userService: UserService,
    private service: Service,
    private partnerService: PartnerService,
    private spinnerService: SpinnerService,
    private commanUsesService: CommanUsesService,
    private expertService: ExpertService,
  ) {
    (pdfMake as any).vfs = pdfFonts.vfs;
    try {
      this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    }
    catch {
      this.groups = [];
    }
  }

  async ngOnInit() {

    /* getting the current logged in user information */
    // this.user = await this.userService.getMyInformation();
    // this.spinnerService.show();
    try {
      const loggedInUserInfo = await this.authStatusService.getTokenInfo();
      if(this.groups.includes('partner')){
        this.loggedInPartner = await this.partnerService.getOne(loggedInUserInfo['extraId']);
      }
      this.user = await this.userService.getMyInformation();
      this.deliveryId = this.route.snapshot.paramMap.get('id');
      await this.getDelivery();
      let services = await this.service.getAllServicess();
      this.services = services.services;
      this.serviceDetailsFunction();
      // console.log('this.delivery', this.delivery)

      //if partner or expert, set readDelivery = true
      //DG
      // if (this.groups.includes('partner') && this.delivery['deluxyDelivery'] && (!this.delivery['readDelivery'])) 

      /* 
      Old code for delivery seen by 
      if ((this.groups.includes('partner') || this.groups.includes('expert')) &&  (!this.delivery['readDelivery'])) 
      {
          let deliveryReadBy = this.groups.includes('partner') ? 'partner' : 'expert';
          let promiseResult: any;
          promiseResult = this.deliveryService.update(this.delivery['id'], {
            id: this.delivery['id'],
            readDelivery: true,
            deliveryReadBy: deliveryReadBy
          });      
      }
      Old code for delivery seen by  
      */

      if(this.groups.includes('partner') && (this.delivery['deliveryReadByPartner']) == null ){
        let promiseResult: any;
        promiseResult = this.deliveryService.update(this.delivery['id'], {
          id: this.delivery['id'],
          readDelivery: true,
          deliveryReadByPartner: this.user.id
        });
      }

      if(this.groups.includes('expert') && (this.delivery['deliveryReadByExpert']) == null ){
        let promiseResult: any;
        promiseResult = this.deliveryService.update(this.delivery['id'], {
          id: this.delivery['id'],
          readDelivery: true,
          deliveryReadByExpert: this.user.id
        });
      }

      if(this.groupWhitelisted(['admin', 'operation'])) {
        let users = await this.userService.getAll(undefined, undefined, undefined, {});
        this.users = users.users || [];
        this.partners = (await this.partnerService.getAllActivePartnersForDelivery().then(res => res.partners));
        if(this.delivery.deliveryReadByPartner) {
          const user = users.users.find((user) => user.id == this.delivery.deliveryReadByPartner);
          const deliveryPartner = await this.partnerService.getOne(user.extraId);
          this.deliveryReadByPartner = deliveryPartner.businessName;
        }
        if(this.delivery.deliveryReadByExpert) {
          const user = users.users.find((user) => user.id == this.delivery.deliveryReadByExpert);
          const deliveryExpert = await this.expertService.getOne(user.extraId);
          this.deliveryReadByExpert =  deliveryExpert.user.surname + " " + deliveryExpert.user.name;
        }

        if(this.delivery.createdUser) {
          const createdByUser = users.users.find((user) => user.id == this.delivery.createdUser);
          if(createdByUser?.group?.name === 'partner' && createdByUser?.extraId) {
            const partner = await this.partnerService.getOne(createdByUser.extraId);
            this.createdByUserName = partner.businessName;
          }
          if(createdByUser?.group?.name === 'admin') {
            this.createdByUserName = createdByUser.surname + " " + createdByUser.name;
          }
          if(createdByUser?.group?.name === 'operation') {
            this.createdByUserName = createdByUser.surname + " " + createdByUser.name;
          }
        }
      }
    }
    catch {
      this.router.navigateByUrl("/404", { skipLocationChange: true });
    }
    // this.spinnerService.hide();
  }

  async getDelivery(){
    this.delivery = await this.deliveryService.getOne(this.deliveryId);
    const delivery = this.delivery;
    this.expertIdentityCheck = this.delivery.expertIdentityCheck;
    this.customerVerification = this.delivery.deliveryCodeRequired;

    if(this.groupWhitelisted(['admin', 'partner', 'operation'])) {
      if(this.delivery.deliveryCodeRequired && this.delivery.deliveryCode) {
        let dialogRef = this.dialog.open(ShowOtpComponent, {
          width: '80vw',
          data: { delivery },
          disableClose: true 
        });
      }
    }
  }


  public groupWhitelisted(groups: string | string[]): boolean {
    if (!Array.isArray(groups))
      return this.groups.includes(groups);
    for (let group of groups)
      if (this.groups.includes(group))
        return true;
    return false;
  }

  print(event: Event) {
    event.preventDefault();
    window.print();
  }

  async showLink(event: Event, type?: string) {
    event.preventDefault();
    if(type === 'delivered' && !this.delivery.deliveredToken) {
      this.delivery = await this.deliveryService.generateMarkDeliveredToken(this.delivery.id);
    }
    if (!this.delivery.identifier) {
      this.delivery = await this.deliveryService.generateIdentifier(this.delivery.id);
    }
    this.dialog.open(DeliveryLinkDialogComponent, { width: '80vw', data: { delivery: this.delivery, type: type } });
  }


  async showDdt(delivery: Delivery) {
    if (!delivery?.ddtFile) return;

    const encodedFileName = encodeURIComponent(delivery.ddtFile);
    const fileUrl = `${env.environment.url}/assets/delivery/ddt/${encodedFileName}`;
    console.log("fileUrl", fileUrl);

    try {
      const response = await fetch(fileUrl);
      console.log("response", response)
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = delivery.ddtFile;

      document.body.appendChild(anchor);
      anchor.click();

      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);

    } catch (err) {
      this.commanUsesService.showSnackBar('Errore download file');
    }
  }

  /*
  async showDdt() {
    let res = await this.deliveryService.findOneDeliveryDdt(this.delivery.id);
    let anchor = document.createElement('a');
    anchor.download = this.delivery.ddtFile.replace(/-.{4}(\..{3,4})$/, '$1');
    anchor.href = (window.webkitURL || window.URL).createObjectURL(res.body);
    anchor.dataset.downloadurl = [res.body.type, anchor.download, anchor.href].join(':');
    anchor.click();
  }
  */

  directions(event: Event) {
    event.preventDefault();
    window.open(`https://www.google.com/maps/dir//${this.delivery.address}`, '_blank');
  }

  public async accepting(id: number) {
    if (!confirm("Accetti la nuova consegna?"))
      return;
    return this.deliveryService.setDeliveryAccepting(id).then(data => {
      // Change delivery status
      //this.deliveries.find(delivery => delivery.id == data.id).status = DeliveryStatus.accepted;
      this.snack(`Consegna aggiornata con successo`);
      window.location.reload();
    }).catch(err => {
      //alert(err);
      this.snack(`Errore nell'aggiornamento della consegna`);
      console.log(err);
    });
  }

  public async refusing(id: number) {
    if (!confirm("Rifiuti la nuova consegna?"))
      return;
    return  this.deliveryService.setDeliveryRefusing(id).then(data => {
      // Change delivery status
      //this.deliveries.find(delivery => delivery.id == data.id).status = DeliveryStatus.notAccepted;
      this.snack(`Consegna aggiornata con successo`);
      window.location.reload();
    }).catch(err => {
      //alert('');
      //alert(err);
      this.snack(`Errore nell'aggiornamento della consegna`);
      console.log(err);
    });
  }  

  snack(message: string) {
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }
  
  delivering(arg){}

  /*
  serviceDetailsFunction(){
    this.serviceDetails = this.services.find((service) => service.id == this.delivery?.service);
    if(this.serviceDetails) {
      if(this.groups.includes('expert')) this.showCustomerInformation = this.delivery?.status != DeliveryStatus.delivered;
      if(this.groups.includes('partner')) this.showCustomerInformation = !this.serviceDetails?.hideCustomerInformation;
    }
  }
  */

  serviceDetailsFunction(): void {
    this.serviceDetails = this.services?.find(
      (service) => service.id == this.delivery?.service
    );

    /**
     * Default:
     * Other users should see customer information.
     */
    this.showCustomerInformation = true;

    if (!this.delivery) {
      this.showCustomerInformation = false;
      return;
    }

    /**
     * Expert condition:
     * Expert can see customer information ONLY when delivery is in delivering state.
     */
    if (this.groups?.includes('expert')) {
      this.showCustomerInformation = this.delivery.status === DeliveryStatus.delivering;
      return;
    }

    /**
     * Partner condition:
     * Partner visibility depends on service hideCustomerInformation setting.
     */
    if (this.groups?.includes('partner')) {
      this.showCustomerInformation = !this.serviceDetails?.hideCustomerInformation;
      return;
    }

    /**
     * All other users:
     * Show customer information.
     */
    this.showCustomerInformation = true;
  }

  showServiceDetails(serviceId: number){
    if(serviceId){
      const service = this.delivery?.partner?.partnerServices?.find((item) => {
        return item?.service?.id == serviceId;
      });
      return service;
    }
  }

  showImage(product: any){
    let ref = this.dialog.open(ShowImageComponent, { panelClass: 'partner-time-dialog', width: '50vw', data: { product } });
    ref.afterClosed().subscribe(result => {});
  }

  public async expertModal(delivery?: Delivery) {
    if(this.groupWhitelisted(['admin', 'operation']) || (this.groups.includes('expert') && this?.user?.expert?.isTeamLeader) ){
      let ref = this.dialog.open(DeliveryExpertFormComponent, { width: '80vw', data: { delivery } });
      ref.afterClosed().subscribe(async (result) => {
        if (result?.delivery){
          let updatedDelivery = result?.delivery;
          await this.getDelivery();
          if(this.groups.includes('admin') || this.groups.includes('operation')){
            let partialUpdateModalRef = this.dialog.open(PartialUpdateDeliveryComponent, { width: '80vw', data: { updatedDelivery } });
            partialUpdateModalRef.afterClosed().subscribe(async (res) => {
              if (res?.delivery){
                await this.getDelivery();
                this.snack(`Price Updated`);
              }
              if (res?.delivery === null){
                this.snack(`Something went wrong`);
              }
            })
          }
        }
      });
    } else {
      return false;
    }
  }


  showNoteInternAndProductManagement(delivery: Delivery) {
    let notesData: string = ``;
    notesData = delivery.internalNotes;
    if(delivery.productManagement && delivery.productManagement != 'none') {
      notesData += delivery.productManagement;
    }
    return notesData;
  }

  showSignature(delivery: Delivery) {
    let dialogRef = this.dialog.open(ShowSignatureComponent, {
      width: '80vw',
      data: { delivery },
      disableClose: true 
    });
  }
  

  async onExpertIdentityCheckChange(id: number, event: any) {
    event.preventDefault();
    const nextState = !this.expertIdentityCheck;
    const confirmAction = confirm('Expert check will be disabled for this delivery. Do you want to proceed?');
    
    let message = ``;
    if (!confirmAction) {
      return;
    }

    try {
      this.spinnerService.show();
      const result = await this.deliveryService.manageValetCheck(id, event.target.checked);
      if (result.id) {
        message = `Expert indentity setting has been change for this delivery`;
      } else {
        message = 'Something went wrong';
      }
    } catch (error) {
      message = error?.error?.message || error?.message || 'Something went wrong';
    } finally {
      await this.getDelivery();
      this.spinnerService.hide();
      this.commanUsesService.showSnackBar(message);
    }
  }

  async onCustomerVerificationChange(id: number, event: any) {
    event.preventDefault();
    const nextState = !this.expertIdentityCheck;
    const confirmAction = confirm('Customer OTP check will be disabled for this delivery. Do you want to proceed?');
    
    let message = ``;
    if (!confirmAction) {
      return;
    }

    try {
      this.spinnerService.show();
      const result = await this.deliveryService.manageCustomerCheck(id, event.target.checked);
      if (result.id) {
        message = `Customer OTP setting has been changed`;
      } else {
        message = 'Something went wrong';
      }
    } catch (error) {
      message = error?.error?.message || error?.message || 'Something went wrong';
    } finally {
      await this.getDelivery();
      this.spinnerService.hide();
      this.commanUsesService.showSnackBar(message);
    }
  }

  toggleDeliveryUpdates(): void {
    this.showDeliveryUpdates = !this.showDeliveryUpdates;
  }

  getDeliveryUpdateUserName(update: any): string {
    if (!update?.userId) {
      return 'N/A';
    }

    const user = this.users?.find((item: any) => {
      return Number(item?.id) === Number(update.userId);
    });

    
    if (!user) {
      return `User ID: ${update.userId}`;
    }

    if(user?.extraType === 'partner') {
      const partner = this.partners?.find((item: any) => {
        return (
          Number(item?.user?.id) === Number(user.id) ||
          Number(item?.userId) === Number(user.id) ||
          Number(item?.id) === Number(user.extraId)
        );
      });

      if (partner?.businessName) {
        return partner.businessName;
      }
    }

    const surname = user.surname || '';
    const name = user.name || '';
    const email = user.email || '';

    const fullName = `${surname} ${name}`.trim();

    return fullName || email || 'N/A';
  }

  get deliveryTimeline() {
    const timeline: any[] = [];

    if (!this.delivery) {
      return [];
    }

    if (this.delivery.createdAt) {
      timeline.push({
        type: 'created',
        label: 'Consegna creata',
        date: this.delivery.createdAt,
        user: this.createdByUserName || 'N/A',
        icon: 'fa-plus-circle',
        className: 'delivery-create',
      });
    }

    if (this.delivery.deliveryStartedAt) {
      timeline.push({
        type: 'started',
        label: 'Consegna partita',
        date: this.delivery.deliveryStartedAt,
        user: this.delivery?.expert
          ? `${this.delivery.expert.user.surname} ${this.delivery.expert.user.name}`
          : 'N/A',
        icon: 'fa-truck',
        className: 'delivery-delivering',
      });
    }

    if (this.delivery.deliveryDeliveredAt) {
      timeline.push({
        type: 'delivered',
        label: 'Consegna effettuata',
        date: this.delivery.deliveryDeliveredAt,
        user: this.delivery?.expert
          ? `${this.delivery.expert.user.surname} ${this.delivery.expert.user.name}`
          : 'N/A',
        icon: 'fa-check-circle',
        className: 'delivery-delivered',
      });
    }

    if (this.delivery?.readDelivery && this.delivery.deliveryReadByPartner) {
      timeline.push({
        type: 'partner-read',
        label: 'Consegna visualizzata Partner',
        date: this.delivery.deliveryReadAtByPartner,
        user: this.deliveryReadByPartner || 'N/A',
        icon: 'fa-eye',
        className: 'green-text',
      });
    }

    if (this.delivery?.readDelivery && this.delivery.deliveryReadByExpert) {
      timeline.push({
        type: 'expert-read',
        label: 'Consegna visualizzata Valet',
        date: this.delivery.deliveryReadAtByExpert,
        user: this.deliveryReadByExpert || 'N/A',
        icon: 'fa-eye',
        className: 'blue-text',
      });
    }

    if (this.delivery?.deliveryUpdates?.length) {
      this.delivery.deliveryUpdates.forEach((update: any, index: number) => {
        if (update?.createdAt) {
          timeline.push({
            type: 'updated',
            label: `Consegna modificata #${index + 1}`,
            date: update.createdAt,
            user: this.getDeliveryUpdateUserName(update),
            icon: 'fa-history',
            className: 'delivery-update',
          });
        }
      });
    }

    return timeline.sort((a, b) => {
      return new Date(a.date).getTime() - new Date(b.date).getTime();
    });
  }

  toggleDeliveryTimeline(): void {
    this.showDeliveryTimeline = !this.showDeliveryTimeline;
  }

}
